var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAileronRegularWebfont(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "aileronregular",
    horizAdvX: 1187
  }, /*#__PURE__*/React.createElement("fontFace", {
    unitsPerEm: 2048,
    ascent: 1577,
    descent: -471
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 442
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB01",
    horizAdvX: 1069,
    d: "M43 942v135h117v29q0 76 6 131q18 152 125 229.5t317 77.5q63 0 125 -10v-145q-200 17 -288.5 -20t-102.5 -136q-6 -43 -6 -111v-45h573v-1077h-176v942h-397v-942h-176v942h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB02",
    horizAdvX: 1042,
    d: "M43 942v135h96v29q0 76 6 131q17 150 118.5 228.5t283.5 78.5q191 0 309 -39v-1194q0 -67 2 -102q3 -53 32.5 -71t100.5 -9v-129q-52 -8 -125 -8q-85 0 -132.5 37t-51.5 133q-2 37 -2 143v1092q-62 12 -141 12q-99 0 -152.5 -48t-64.5 -128q-7 -51 -7 -111v-45h224v-135 h-224v-942h-176v942h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 682
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 442
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\t",
    horizAdvX: 442
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 442
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 495,
    d: "M117 102q0 57 37 94t94 37t94 -37t37 -94t-37 -94t-94 -37t-94 37t-37 94zM143 1413h209l-24 -1044h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 694,
    d: "M176 1505h184l-20 -512h-143zM463 1505h184l-20 -512h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    d: "M143 449v114h209l60 287h-207v115h231l96 448h119l-96 -448h186l97 448h118l-96 -448h184v-115h-208l-60 -287h207v-114h-231l-97 -449h-118l96 449h-187l-96 -449h-119l97 449h-185zM471 563h186l62 287h-187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    d: "M109 381h188q14 -110 78 -179.5t172 -86.5v524q-192 53 -289.5 146.5t-97.5 261.5q0 169 106.5 271t280.5 120v159h119v-157q118 -10 205 -66.5t133 -140.5t59 -191h-189q-23 228 -208 256v-487q223 -71 317 -174.5t94 -265.5q0 -167 -115.5 -272.5t-295.5 -123.5v-159 h-119v157q-196 12 -313.5 121t-124.5 287zM348 1073q0 -100 47 -155.5t152 -88.5v469q-94 -15 -146.5 -72.5t-52.5 -152.5zM666 113q104 13 163.5 72t59.5 165q0 95 -51.5 161t-171.5 105v-503z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1515,
    d: "M84 1108q0 150 82 238t221 88t221 -88t82 -238q0 -149 -82.5 -237.5t-220.5 -88.5t-220.5 88.5t-82.5 237.5zM211 0l917 1413h179l-918 -1413h-178zM256 1108q0 -96 35.5 -149.5t95.5 -53.5t95.5 53.5t35.5 149.5q0 98 -35.5 150.5t-95.5 52.5t-95.5 -52.5t-35.5 -150.5z M825 297q0 150 82 238t221 88t221.5 -88t82.5 -238q0 -149 -83 -237.5t-221 -88.5t-220.5 88.5t-82.5 237.5zM997 297q0 -96 35.5 -149.5t95.5 -53.5t96 53.5t36 149.5q0 97 -36 150t-96 53t-95.5 -52.5t-35.5 -150.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1339,
    d: "M131 354q0 130 88 232.5t236 134.5q-121 29 -194 111.5t-73 203.5q0 181 139.5 293.5t360.5 112.5q129 0 246 -21v-141q-121 23 -252 23q-139 0 -218 -68.5t-79 -187.5q0 -135 69.5 -192t196.5 -64q55 -3 127 -3h123v230h176v-230h197v-143h-197v-631q-186 -43 -387 -43 q-130 0 -227.5 18.5t-174.5 60.5t-117 118.5t-40 185.5zM328 381q0 -146 86 -208t280 -62q117 0 207 18v516h-123q-84 0 -125 -4q-168 -14 -246.5 -84t-78.5 -176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 360,
    d: "M88 1505h184l-20 -512h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 645,
    d: "M205 717q0 241 66 473.5t182 406.5h118q-114 -193 -176.5 -421.5t-62.5 -458.5t62.5 -459.5t176.5 -421.5h-118q-116 174 -182 406.5t-66 474.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 645,
    d: "M61 -164q114 193 177 422.5t63 458.5t-62.5 458t-177.5 422h119q116 -174 182 -406.5t66 -473.5q0 -242 -66 -474.5t-182 -406.5h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 1146,
    d: "M174 610l39 121l317 -125l-20 367h127l-21 -367l318 125l39 -121l-326 -84l232 -282l-103 -76l-203 313l-202 -313l-103 76l232 282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    d: "M164 588v114h371v422h118v-422h371v-114h-371v-414h-118v414h-371z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 450,
    d: "M-63 -246l159 451h191v-21l-185 -430h-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 561,
    d: "M66 522v115h430v-115h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 450,
    d: "M76 102q0 57 37 94t94 37t94 -37t37 -94t-37 -94t-94 -37t-94 37t-37 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 620,
    d: "M-10 -61l514 1536h127l-514 -1536h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    d: "M84 707q0 735 510 735t510 -735q0 -736 -510 -736t-510 736zM281 707q0 -596 313 -596t313 596t-313 596t-313 -596z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    d: "M266 995v187l299 186q71 45 154 45h112v-1413h-176v1227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    d: "M123 0v100l512 523q91 93 139.5 153t77.5 124.5t29 131.5q0 116 -66 193.5t-188 77.5q-260 0 -291 -312l-2 -20h-176l2 20q22 220 148 335.5t339 115.5q105 0 188.5 -31t135.5 -84.5t79 -123.5t27 -150q0 -95 -38.5 -181.5t-106.5 -167.5t-199 -210l-354 -351h692v-143 h-948z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    d: "M92 418h176l2 -21q14 -143 103 -214.5t225 -71.5q133 0 216 72.5t83 199.5t-83.5 193.5t-252.5 66.5h-35v143h35q131 0 217 74t86 203q0 106 -69 173t-181 67q-117 0 -196 -71t-92 -206l-2 -20h-177l3 20q21 194 147.5 305t339.5 111q194 0 309 -99t115 -260 q0 -120 -69 -209t-181 -122q133 -37 208 -130t75 -229q0 -128 -71.5 -225.5t-187 -147t-253.5 -49.5q-211 0 -338.5 103t-149.5 323z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    d: "M68 356v88l700 969h176v-913h178v-144h-178v-356h-176v356h-700zM291 500h477v678q-64 -106 -117 -181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    d: "M117 395h176l4 -20q54 -264 297 -264q141 0 225 88.5t84 246.5q0 160 -80.5 253.5t-220.5 93.5q-101 0 -172.5 -47t-122.5 -154h-168l99 821h802v-143h-659l-64 -492l89 94q100 60 223 60q153 0 261 -63t159 -168t51 -242q0 -113 -42 -207t-112 -154.5t-160.5 -93.5 t-189.5 -33q-214 0 -335.5 102.5t-141.5 301.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    d: "M88 639q0 206 44 364t121 252t173 140.5t209 46.5q181 0 300 -104t136 -277l2 -21h-188l-4 21q-50 242 -260 242q-151 0 -240.5 -135.5t-99.5 -430.5l79 127q109 90 258 90q218 0 343.5 -132.5t125.5 -346.5q0 -224 -141 -364t-358 -140q-500 0 -500 668zM293 459 q0 -150 81.5 -249t213.5 -99q133 0 218 95.5t85 248.5q0 76 -17.5 139.5t-53 114t-95 78.5t-137.5 28q-127 0 -211 -93t-84 -263z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    d: "M102 1270v143h1000v-82l-705 -1331h-188l678 1270h-785z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    d: "M90 395q0 123 81 218t200 132q-99 38 -159 121t-60 195q0 175 123.5 278t330.5 103t331 -103.5t124 -277.5q0 -112 -65 -194t-169 -119q118 -38 194.5 -133.5t76.5 -219.5q0 -90 -29 -163t-77 -121t-113.5 -80.5t-136.5 -47t-148 -14.5q-83 0 -155.5 14.5t-137.5 47 t-111 81t-73 121t-27 162.5zM287 387q0 -126 80 -202t231 -76q150 0 226.5 75.5t76.5 202.5q0 119 -75.5 198t-229.5 79q-79 0 -140 -22.5t-97 -62t-54 -88t-18 -104.5zM342 1055q0 -112 67.5 -182t194.5 -70q128 0 197 70t69 182q0 107 -68 177.5t-196 70.5t-196 -70.5 t-68 -177.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    d: "M100 938q0 224 141.5 364t358.5 140q500 0 500 -668q0 -206 -44 -364t-121 -252t-173 -140.5t-209 -46.5q-181 0 -300 104t-136 277l-2 21h188l4 -21q50 -241 260 -241q321 0 340 565l-80 -127q-109 -90 -258 -90q-218 0 -343.5 132.5t-125.5 346.5zM297 958 q0 -76 17.5 -139.5t53 -114t95 -78.5t137.5 -28q127 0 211 93t84 263q0 150 -81.5 249.5t-213.5 99.5q-133 0 -218 -96t-85 -249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 450,
    d: "M76 102q0 57 37 94t94 37t94 -37t37 -94t-37 -94t-94 -37t-94 37t-37 94zM76 983q0 57 37 94t94 37t94 -37t37 -94t-37 -94t-94 -37t-94 37t-37 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 450,
    d: "M-63 -246l159 471h193v-24l-185 -447h-167zM76 983q0 57 37 94t94 37t94 -37t37 -94t-37 -94t-94 -37t-94 37t-37 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    d: "M211 473v139l821 412v-139l-700 -340l700 -340v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    d: "M164 383v115h860v-115h-860zM164 793v114h860v-114h-860z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    d: "M139 61v140l701 340l-701 340v143l822 -412v-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 1021,
    d: "M72 1012q6 196 132 313t328 117q200 0 313 -105.5t113 -269.5q0 -106 -52.5 -207t-162.5 -211q-93 -93 -124.5 -148.5t-36.5 -131.5h-176q9 91 43 160t120 167q112 128 152.5 204.5t40.5 166.5q0 107 -63.5 171.5t-172.5 64.5q-117 0 -189 -75.5t-81 -215.5h-184z M362 102q0 57 37.5 94t94.5 37t94 -37t37 -94t-37 -94t-94 -37t-94.5 37t-37.5 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1744,
    d: "M111 498q0 158 48 297t130.5 241t190.5 176t231.5 111t249.5 37q291 0 474 -188.5t183 -493.5q0 -133 -37.5 -237.5t-99.5 -165t-134 -91t-149 -30.5q-84 0 -139 36t-66 111l-43 -84q-96 -80 -205 -80q-53 0 -101 17t-91.5 53.5t-69.5 103.5t-26 156q0 134 55.5 253 t158 194t228.5 75q123 0 180 -63l19 -99l35 125h165l-129 -540q-8 -36 -8 -66q0 -34 16 -54t62 -20q101 0 176.5 104.5t75.5 297.5q0 110 -28 203t-77.5 159.5t-117 113t-147 69t-167.5 22.5q-104 0 -206.5 -31t-194.5 -94t-162 -150t-111.5 -208t-41.5 -258 q0 -145 45.5 -259.5t125.5 -187t183.5 -110t224.5 -37.5q131 0 268.5 42t245.5 122l49 -101q-268 -182 -569 -182q-110 0 -212 27.5t-191 85.5t-155 140.5t-104 200t-38 257.5zM649 479q0 -108 38 -157.5t101 -49.5q81 0 145 72t87 170l18 80q31 138 -7 199t-120 61 q-80 0 -141 -55t-91 -139.5t-30 -180.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1308,
    d: "M59 0l508 1413h238l487 -1413h-190l-168 500h-520l-166 -500h-189zM463 643h424l-205 631z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1284,
    d: "M205 0v1413h416q116 0 184 -8q170 -24 259 -109.5t89 -234.5q0 -228 -240 -309q144 -33 217.5 -113.5t73.5 -222.5q0 -93 -30 -167.5t-82.5 -122t-115.5 -76.5t-136 -40q-70 -10 -181 -10h-454zM381 143h305q44 0 98 4q105 9 168.5 73.5t63.5 176.5q0 123 -60 182 t-170 74q-70 9 -112 9h-293v-519zM381 805h272q58 0 113 8q199 32 199 234q0 100 -58 154t-159 65q-37 4 -113 4h-254v-465z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1431,
    d: "M96 700q0 214 82.5 382.5t235.5 264t350 95.5q131 0 236 -36t175 -100.5t111.5 -151t52.5 -191.5l2 -21h-176l-4 21q-32 160 -131.5 250t-269.5 90q-213 0 -340 -166.5t-127 -427.5q0 -264 124 -431t331 -167q170 0 269.5 90t131.5 250l4 20h176l-2 -20 q-10 -98 -51.5 -183t-113 -152.5t-181 -106t-244.5 -38.5q-151 0 -273.5 55.5t-202 153.5t-122.5 231t-43 289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1452,
    d: "M205 0v1413h430q108 0 180 -8q257 -32 408 -204.5t151 -477.5q0 -304 -158 -493.5t-411 -221.5q-72 -8 -180 -8h-420zM381 143h233q110 0 172 11q184 30 290 177t106 392q0 232 -101 369.5t-284 167.5q-56 10 -172 10h-244v-1127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1202,
    d: "M205 0v1413h919v-143h-743v-492h682v-143h-682v-492h764v-143h-940z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1161,
    d: "M205 0v1413h919v-143h-743v-492h661v-143h-661v-635h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1454,
    d: "M96 700q0 214 82.5 382.5t235.5 264t350 95.5q131 0 236 -36t175 -100.5t111.5 -151t52.5 -191.5l2 -21h-176l-4 21q-32 160 -131.5 250t-269.5 90q-213 0 -340 -166.5t-127 -427.5q0 -264 124 -431t331 -167q173 0 286 120t113 308h-330v143h506v-682h-156v246l-63 -131 q-128 -144 -367 -144q-151 0 -273.5 55.5t-202 153.5t-122.5 231t-43 289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1495,
    d: "M205 0v1413h176v-647h778v647h176v-1413h-176v618h-778v-618h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 540,
    d: "M205 0v1413h176v-1413h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 1114,
    d: "M113 481h176l4 -84q15 -286 270 -286q120 0 184.5 71t73.5 199q2 41 2 166v866h176v-872q0 -100 -4 -170q-11 -186 -125 -293t-331 -107q-196 0 -307.5 113.5t-116.5 312.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1247,
    d: "M205 0v1413h176v-751l698 751h207l-641 -690l604 -723h-248l-485 604l-135 -145v-459h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1177,
    d: "M205 0v1413h176v-1270h764v-143h-940z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1773,
    d: "M205 0v1413h291l417 -1263l416 1263h285v-1413h-176v727q0 372 4 526q-62 -205 -172 -524l-250 -729h-221l-254 733q-120 352 -168 516q4 -154 4 -522v-727h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1470,
    d: "M205 0v1413h270l666 -1241q-6 249 -6 535v706h172l4 -1413h-271l-665 1241q6 -249 6 -534v-707h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1509,
    d: "M96 707q0 217 76.5 382t228.5 259t363 94t363 -94t228.5 -259t76.5 -382t-76.5 -381.5t-229 -259.5t-362.5 -95t-362.5 95t-229 259.5t-76.5 381.5zM293 707q0 -277 125 -436.5t346 -159.5t346 159.5t125 436.5q0 278 -124.5 437t-346.5 159t-346.5 -159t-124.5 -437z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1224,
    d: "M205 0v1413h438q121 0 184 -8q172 -22 269.5 -127.5t97.5 -282.5q0 -173 -103 -280.5t-264 -128.5q-63 -8 -184 -8h-262v-578h-176zM381 725h278q109 0 158 10q84 19 136.5 82t52.5 178t-52.5 178t-136.5 82q-54 11 -158 11h-278v-541z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 1501,
    d: "M96 707q0 217 76.5 382t228.5 259t363 94t363 -94t228.5 -259t76.5 -382q0 -179 -66 -323.5t-192 -236.5q125 -19 262 -133l-101 -120q-98 66 -157.5 88t-118.5 22q-65 0 -150 -18q-67 -15 -145 -15q-210 0 -362.5 95t-229 259.5t-76.5 381.5zM293 707q0 -277 125 -436.5 t346 -159.5t346 159.5t125 436.5q0 278 -124.5 437t-346.5 159t-346.5 -159t-124.5 -437z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1267,
    d: "M205 0v1413h463q121 0 184 -8q163 -21 257.5 -114t94.5 -263q0 -130 -71.5 -215t-180.5 -119q82 -38 127.5 -124t55.5 -199q13 -147 33 -232t61 -139h-195q-52 119 -76 354q-13 116 -62 180.5t-148 71.5q-33 2 -101 2h-266v-608h-176zM381 752h270q98 0 137 4 q103 9 165.5 74.5t62.5 181.5q0 115 -52.5 174.5t-154.5 75.5q-52 8 -141 8h-287v-518z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1198,
    d: "M106 401h189q31 -139 123.5 -214.5t230.5 -75.5q125 0 209 64t84 171q0 127 -78.5 195.5t-267.5 111.5q-79 18 -140.5 40t-116 55t-90.5 74t-56.5 97.5t-20.5 124.5q0 119 63.5 210.5t170.5 139.5t237 48q211 0 331.5 -115t141.5 -305h-188q-12 134 -89 207.5t-210 73.5 q-118 0 -193.5 -56t-75.5 -162q0 -113 69.5 -171.5t234.5 -96.5q239 -55 352.5 -158.5t113.5 -279.5q0 -121 -64.5 -215t-174.5 -143.5t-246 -49.5q-233 0 -374.5 113t-164.5 317z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1253,
    d: "M70 1270v143h1183v-143h-503v-1270h-177v1270h-503z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1396,
    d: "M193 522v891h176v-874q0 -88 4 -125q12 -138 102 -220.5t248 -82.5t248 82.5t102 220.5q4 37 4 125v874h176v-891q0 -86 -4 -127q-8 -91 -43 -166.5t-97.5 -134t-161 -91t-224.5 -32.5t-224.5 32.5t-161 91t-97.5 134t-43 166.5q-4 41 -4 127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1273,
    d: "M66 1413h190l420 -1280l434 1280h188l-507 -1413h-238z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 1949,
    d: "M53 1413h201l297 -1255l328 1235h237l320 -1237l313 1257h186l-393 -1413h-231l-320 1219l-332 -1219h-233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1280,
    d: "M51 0l504 713l-467 700h201l375 -577l389 577h202l-491 -694l512 -719h-207l-414 598l-401 -598h-203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1189,
    d: "M39 1413h203l393 -686l381 686h198l-499 -856v-557h-176v557z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1210,
    d: "M94 0v135l854 1135h-796v143h1001v-141l-850 -1129h862v-143h-1071z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 628,
    d: "M201 -164v1761h334v-114h-216v-1532h216v-115h-334z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 620,
    d: "M-10 1475h127l514 -1536h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 604,
    d: "M70 -49h215v1532h-215v114h333v-1761h-333v115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    d: "M164 440l360 822h140l360 -822h-139l-289 707l-289 -707h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 1024,
    d: "M102 -61h820v-115h-820v115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 614,
    d: "M84 1413h164l125 -225h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1087,
    d: "M74 281q0 187 147.5 279.5t462.5 92.5h70v29q0 90 -4 131q-13 166 -211 166q-216 0 -234 -229h-184q12 172 124 268t294 96q187 0 279 -74t106 -213q6 -64 6 -143v-408q0 -125 20 -276h-176l-18 156l-60 -117q-99 -68 -272 -68q-153 0 -251.5 82t-98.5 228zM266 295 q0 -96 57 -142.5t160 -46.5q125 0 198 80t73 226v110q-57 4 -108 4q-156 0 -252 -41q-128 -55 -128 -190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1251,
    d: "M152 0v1505h176v-594l82 117q46 38 124.5 62t161.5 24q155 0 268 -73t169.5 -197.5t56.5 -284.5q0 -146 -43 -260.5t-117.5 -184.5t-168.5 -106.5t-202 -36.5q-71 0 -145.5 19.5t-114.5 52.5l-71 107v-150h-176zM328 494q0 -101 29.5 -178.5t78 -121.5t105.5 -66t118 -22 q149 0 243.5 113t94.5 320q0 125 -35.5 223t-111 157.5t-180.5 59.5q-70 0 -129.5 -23.5t-108.5 -72t-76.5 -133t-27.5 -197.5v-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 1083,
    d: "M61 541q0 134 41.5 244t112 181t162 109.5t194.5 38.5q192 0 313 -106t146 -287h-184q-58 258 -279 258q-136 0 -224.5 -108.5t-88.5 -317.5q0 -224 85 -335.5t216 -111.5q108 0 180.5 61t100.5 179h184q-39 -185 -164 -280t-311 -95q-105 0 -191.5 34t-153 101.5 t-103 178.5t-36.5 256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1259,
    d: "M61 526q0 146 43 260.5t117.5 184.5t168.5 106.5t202 36.5q71 0 145.5 -19.5t114.5 -52.5l72 -106v569h176v-1505h-176v174l-82 -117q-46 -38 -125 -62t-162 -24q-155 0 -268 73t-169.5 197.5t-56.5 284.5zM254 547q0 -125 36 -223.5t111.5 -158t180.5 -59.5 q70 0 129.5 23.5t108.5 72t76.5 133t27.5 197.5v60q0 101 -29.5 178.5t-78.5 121.5t-106 65.5t-118 21.5q-149 0 -243.5 -113t-94.5 -319z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1124,
    d: "M61 539q0 260 145.5 417.5t371.5 157.5q219 0 341.5 -148.5t122.5 -392.5q0 -45 -4 -84h-786q11 -202 95.5 -292.5t215.5 -90.5q108 0 185.5 64.5t95.5 179.5h184q-16 -95 -60.5 -169t-109 -119t-141 -68t-162.5 -23q-107 0 -196.5 35.5t-156.5 104.5t-104 178.5 t-37 249.5zM254 625h610q-12 171 -85.5 262.5t-205.5 91.5t-218 -92t-101 -262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 593,
    d: "M43 942v135h117v90q0 75 6 131q13 118 89 182t198 64q63 0 125 -10v-145q-44 8 -81 8q-47 0 -83 -13q-62 -25 -72 -90q-6 -44 -6 -110v-107h223v-135h-223v-942h-176v942h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1259,
    d: "M61 526q0 146 43 260.5t117.5 184.5t168.5 106.5t202 36.5q71 0 145.5 -19.5t114.5 -52.5l72 -106v149h176v-819q0 -152 -2 -211q-7 -235 -143 -360t-373 -125q-450 0 -486 358l-2 21h178l2 -19q11 -102 91.5 -163.5t216.5 -61.5q160 0 247 87t93 245q2 51 2 119v18 l-82 -117q-46 -38 -125 -62t-162 -24q-155 0 -268 73t-169.5 197.5t-56.5 284.5zM254 547q0 -125 36 -223.5t111.5 -158t180.5 -59.5q70 0 129.5 23.5t108.5 72t76.5 133t27.5 197.5v60q0 101 -29.5 178.5t-78.5 121.5t-106 65.5t-118 21.5q-149 0 -243.5 -113t-94.5 -319z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1214,
    d: "M152 0v1516h176v-617l67 125q66 52 130.5 71t152.5 19q175 0 275 -85.5t112 -231.5q4 -55 4 -187v-610h-176v598q0 101 -4 156q-9 104 -69 164q-58 58 -168 57h-11q-53 -1 -98 -17.5t-85.5 -53t-68.5 -92.5t-44.5 -141.5t-16.5 -193.5v-477h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 487,
    d: "M127 1329q0 47 33 80t80 33t79.5 -33t32.5 -80t-32.5 -79.5t-79.5 -32.5t-80 32.5t-33 79.5zM152 0v1085h176v-1085h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 477,
    d: "M-27 -283q19 -2 36 -2q55 0 84 17q38 23 44 75q4 29 4 91v1187h176v-1179q0 -76 -6 -131q-11 -102 -71.5 -153.5t-182.5 -51.5q-57 0 -84 4v143zM117 1329q0 47 32.5 80t79.5 33t80 -33t33 -80t-33 -79.5t-80 -32.5t-79.5 32.5t-32.5 79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 1069,
    d: "M152 0v1505h176v-966l506 546h225l-506 -512l512 -573h-240l-395 459l-102 -113v-346h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 505,
    d: "M143 305v1200h176v-1194q0 -49 3 -102t32 -71q21 -13 64 -13q17 0 37 2v-127q-52 -8 -125 -8q-85 0 -133 37t-52 133q-2 37 -2 143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1751,
    d: "M152 0v1085h176v-157l69 123q77 63 230 63q120 0 200.5 -55t112.5 -148l96 140q77 63 230 63q140 0 224.5 -73t104.5 -191q11 -76 11 -186v-664h-176v582q0 128 -9 211q-24 182 -217 182q-237 0 -237 -438v-537h-176v582q0 128 -9 211q-24 182 -217 182q-237 0 -237 -438 v-537h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1214,
    d: "M152 0v1085h176v-186l67 125q66 52 130.5 71t152.5 19q175 0 275 -85.5t112 -231.5q4 -55 4 -187v-610h-176v598q0 101 -4 156q-8 102 -68 161.5t-180 59.5q-67 0 -121.5 -26.5t-98.5 -82.5t-68.5 -155t-24.5 -234v-477h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1200,
    d: "M61 543q0 118 33 219.5t97.5 181t169.5 125t239 45.5t239 -45.5t169.5 -125t97.5 -181t33 -219.5q0 -117 -33 -218.5t-97.5 -181.5t-169.5 -126t-239 -46t-239 46t-169.5 126t-97.5 181.5t-33 218.5zM254 543q0 -195 92.5 -316t253.5 -121t253.5 121t92.5 316 q0 196 -92.5 316t-253.5 120t-253.5 -120t-92.5 -316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1251,
    d: "M152 -401v1486h176v-174l82 117q46 38 124.5 62t161.5 24q155 0 268 -73t169.5 -197.5t56.5 -284.5q0 -146 -43 -260.5t-117.5 -184.5t-168.5 -106.5t-202 -36.5q-71 0 -145.5 19.5t-114.5 52.5l-71 107v-551h-176zM328 494q0 -101 29.5 -178.5t78 -121.5t105.5 -66 t118 -22q149 0 243.5 113t94.5 320q0 125 -35.5 223t-111 157.5t-180.5 59.5q-70 0 -129.5 -23.5t-108.5 -72t-76.5 -133t-27.5 -197.5v-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1259,
    d: "M61 526q0 146 43 260.5t117.5 184.5t168.5 106.5t202 36.5q71 0 145.5 -19.5t114.5 -52.5l72 -106v149h176v-1486h-176v575l-82 -117q-46 -38 -125 -62t-162 -24q-155 0 -268 73t-169.5 197.5t-56.5 284.5zM254 547q0 -125 36 -223.5t111.5 -158t180.5 -59.5 q70 0 129.5 23.5t108.5 72t76.5 133t27.5 197.5v60q0 101 -29.5 178.5t-78.5 121.5t-106 65.5t-118 21.5q-149 0 -243.5 -113t-94.5 -319z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 675,
    d: "M152 0v1085h176v-170l98 146q71 49 152 49q45 0 73 -14v-133q-14 1 -27 1q-127 0 -207 -80q-89 -88 -89 -266v-618h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 940,
    d: "M49 319h184q39 -213 254 -213q92 0 151.5 41.5t59.5 116.5q0 77 -59 124.5t-197 84.5q-80 22 -138 47t-109 63t-77 91.5t-26 122.5q0 147 102.5 232t272.5 85q177 0 279 -91.5t120 -246.5h-184q-19 97 -77 150t-152 53q-89 0 -135 -44t-46 -118q0 -76 57.5 -116.5 t180.5 -73.5q192 -51 280.5 -132t88.5 -216q0 -148 -112.5 -228t-291.5 -80q-176 0 -289 85.5t-137 262.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 641,
    d: "M41 942v135h145v252h176v-252h203v-135h-203v-625q0 -41 3 -84q6 -77 45 -99q25 -15 79 -15q28 0 64 4v-129q-64 -10 -150 -10q-103 0 -155.5 45t-59.5 145q-2 29 -2 135v633h-145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1212,
    d: "M135 434v651h176v-618q0 -77 8 -150q12 -94 78 -150t174 -56q66 0 119.5 26t96.5 82.5t66.5 155t23.5 233.5v477h176v-1085h-176v184l-68 -127q-66 -49 -130.5 -67.5t-152.5 -18.5q-161 0 -261 79t-120 198q-10 69 -10 186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 1052,
    d: "M2 1085h195l331 -956l326 956h186l-411 -1085h-215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1607,
    d: "M2 1085h203l252 -917l237 917h219l242 -911l252 911h188l-346 -1085h-209l-241 913l-242 -913h-209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 987,
    d: "M-12 0l389 549l-375 536h209l272 -419l273 419h202l-380 -532l385 -553h-205l-285 436l-283 -436h-202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 1050,
    d: "M2 1085h199l323 -954l322 954h192l-446 -1177q-67 -173 -158.5 -255.5t-222.5 -82.5q-63 0 -90 4v143q27 -2 63 -2q84 0 140 43.5t96 147.5l14 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 946,
    d: "M41 0v135l631 803h-586v139h791v-141l-627 -797h637v-139h-846z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 620,
    d: "M131 659v115q89 9 128.5 48.5t39.5 109.5q0 63 -23 225q-24 174 -24 223q0 120 69 168.5t209 48.5h23v-114h-25q-87 0 -122 -25.5t-35 -75.5q0 -44 22 -204q27 -193 27 -252q0 -89 -46.5 -142.5t-131.5 -64.5q83 -11 130.5 -66.5t47.5 -144.5q0 -59 -27 -252 q-22 -160 -22 -205q0 -50 35 -75t122 -25h25v-115h-23q-140 0 -209 48.5t-69 168.5q0 49 24 223q23 162 23 226q0 70 -39.5 109t-128.5 48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 512,
    d: "M197 -410v2048h118v-2048h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 620,
    d: "M68 -49h24q87 0 122.5 25t35.5 75q0 38 -23 205q-26 186 -26 252q0 89 46.5 142.5t131.5 64.5q-83 11 -130.5 66.5t-47.5 144.5q0 66 26 252q23 167 23 204q0 50 -35.5 75.5t-122.5 25.5h-24v114h22q140 0 209.5 -48.5t69.5 -168.5q0 -42 -25 -223q-22 -155 -22 -225 t39 -109.5t128 -48.5v-115q-89 -9 -128 -48t-39 -109q0 -71 22 -226q25 -181 25 -223q0 -120 -69.5 -168.5t-209.5 -48.5h-22v115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    d: "M158 457q0 272 225 272q55 0 101 -17.5t137 -66.5q47 -25 73 -38t59 -23.5t60 -10.5q56 0 78 39.5t22 116.5h115q0 -272 -225 -272q-55 0 -101 17.5t-137 66.5q-68 37 -110.5 54t-81.5 17q-56 0 -78.5 -39t-22.5 -116h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 495,
    d: "M117 983q0 57 37 94t94 37t94 -37t37 -94t-37 -94t-94 -37t-94 37t-37 94zM143 -328l25 1045h160l24 -1045h-209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    horizAdvX: 1146,
    d: "M100 541q0 120 34.5 222t94 172t138 114.5t168.5 58.5v162h118v-158q173 -10 282.5 -115t133.5 -276h-184q-52 230 -232 254v-864q174 31 221 235h185q-35 -167 -141 -261.5t-265 -109.5v-159h-118v157q-198 16 -316.5 158t-118.5 410zM293 553q0 -197 67 -307t175 -133 v858q-109 -26 -175.5 -132.5t-66.5 -285.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    d: "M139 0v127q117 29 170 106t53 177q0 118 -55 239h-149v115h94q-64 144 -64 256q0 186 126.5 304t312.5 118q198 0 307.5 -110.5t122.5 -291.5h-189q-19 134 -78.5 198.5t-166.5 64.5q-115 0 -176.5 -74t-61.5 -174q0 -79 15.5 -135t60.5 -156h442v-115h-395 q41 -105 41 -209q0 -101 -37.5 -168.5t-118.5 -128.5h668v-143h-922z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    d: "M172 281l123 120q-70 92 -70 215q0 119 70 218l-123 122l84 84l123 -122q95 67 215 67q123 0 215 -70l125 125l84 -84l-125 -125q70 -92 70 -215q0 -119 -68 -215l123 -122l-84 -84l-123 122q-98 -69 -217 -69q-125 0 -215 69l-123 -120zM352 616q0 -108 69.5 -178.5 t172.5 -70.5t172.5 70.5t69.5 178.5t-69.5 179t-172.5 71t-172.5 -71t-69.5 -179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    d: "M47 1413h217l338 -678l332 678h207l-377 -682h250v-115h-314l-18 -32v-99h332v-114h-332v-371h-176v371h-332v114h332v99l-19 32h-313v115h250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 512,
    d: "M197 -328v697h118v-697h-118zM197 717v696h118v-696h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 1146,
    d: "M68 602q0 113 57 191.5t156 115.5q-82 88 -82 209q0 150 103 237t265 87q178 0 280 -90.5t120 -249.5h-185q-19 97 -74.5 151t-140.5 54q-79 0 -129.5 -45t-50.5 -125q0 -86 67 -145t210 -99q223 -62 323 -152.5t100 -236.5q0 -97 -55 -176t-147 -121q84 -94 84 -234 q0 -106 -58.5 -182.5t-148.5 -111.5t-199 -35q-180 0 -294.5 89t-135.5 267h184q55 -221 258 -221q91 0 148 47t57 133q0 93 -67 154.5t-240 103.5q-184 45 -294.5 142.5t-110.5 242.5zM256 610q0 -82 76.5 -144t208.5 -93q112 -26 204 -68q70 15 112 65.5t42 112.5 q0 91 -69.5 147t-233.5 107q-98 30 -174 70q-75 -6 -120.5 -55.5t-45.5 -141.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 614,
    d: "M63 1288q0 38 28.5 66t66.5 28t66 -28t28 -66t-28 -66t-66 -28t-66.5 28t-28.5 66zM362 1288q0 38 28.5 66t66.5 28t66 -28t28 -66t-28 -66t-66 -28t-66.5 28t-28.5 66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 1716,
    d: "M74 727q0 166 61 314t165.5 254t250 167.5t307.5 61.5t307.5 -61.5t250 -167.5t165.5 -254t61 -314t-61 -314t-165.5 -254t-250 -167.5t-307.5 -61.5t-307.5 61.5t-250 167.5t-165.5 254t-61 314zM201 727q0 -190 86.5 -345.5t237 -244t333.5 -88.5q137 0 259 52 t209.5 142t138.5 216t51 268q0 141 -51 267t-138.5 216t-209.5 142.5t-259 52.5q-183 0 -333.5 -89t-237 -244.5t-86.5 -344.5zM428 723q0 219 121 348t321 129q163 0 269.5 -90t136.5 -240h-189q-16 87 -69 139t-148 52q-118 0 -181.5 -89t-63.5 -243t66.5 -245t178.5 -91 q86 0 144 55t71 136h189q-37 -153 -141.5 -241.5t-280.5 -88.5q-189 0 -306.5 129t-117.5 340z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 1140,
    d: "M246 508l280 340h150l-281 -340l281 -340h-150zM594 508l280 340h150l-281 -340l281 -340h-150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    d: "M205 672v114h756v-356h-119v242h-637z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 561,
    d: "M66 522v115h430v-115h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 1040,
    d: "M90 1135q0 189 120.5 309.5t309.5 120.5t309.5 -120.5t120.5 -309.5t-120.5 -309.5t-309.5 -120.5t-309.5 120.5t-120.5 309.5zM188 1135q0 -148 93 -242t239 -94t239 94t93 242t-93 241.5t-239 93.5t-239 -93.5t-93 -241.5zM367 932v418h143q37 0 55 -2 q137 -14 137 -113q0 -73 -88 -102q59 -10 66 -91q7 -64 27 -110h-117q-10 40 -15 92q-5 47 -59 47h-47v-139h-102zM469 1157h41q27 0 39 2q41 8 41 53q0 42 -41 52q-12 2 -39 2h-41v-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 614,
    d: "M61 1237v106h492v-106h-492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 610,
    d: "M57 1198q0 108 69.5 176t178.5 68t178.5 -68t69.5 -176t-69.5 -176t-178.5 -68t-178.5 68t-69.5 176zM184 1198q0 -57 34 -93t87 -36t87 36t34 93t-34 93t-87 36t-87 -36t-34 -93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    d: "M164 0v115h860v-115h-860zM164 596v115h371v360h118v-360h371v-115h-371v-369h-118v369h-371z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 614,
    d: "M238 1188l124 225h164l-174 -225h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 1159,
    d: "M90 1034q0 153 85.5 260.5t236.5 116.5q35 2 114 2h473v-1638h-118v1523h-189v-1523h-119v880h-47q-79 0 -114 2q-151 9 -236.5 116.5t-85.5 260.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 413,
    d: "M66 625q0 60 40.5 100.5t100.5 40.5t100.5 -40.5t40.5 -100.5t-40.5 -101t-100.5 -41t-100.5 41t-40.5 101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 614,
    d: "M135 -322q43 -22 109 -22q62 0 94.5 24t32.5 66q0 54 -47 77.5t-150 16.5l96 178h109l-55 -100q81 -10 123 -54t42 -116q0 -85 -68 -131.5t-183 -46.5q-60 0 -103 18v90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 1140,
    d: "M117 168l280 340l-280 340h149l281 -340l-281 -340h-149zM465 168l280 340l-280 340h149l281 -340l-281 -340h-149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 1005,
    d: "M135 18q0 106 52.5 207t162.5 211q93 93 125 149t37 132h176q-9 -91 -43.5 -160.5t-120.5 -167.5q-111 -127 -151.5 -204t-40.5 -167q0 -107 63 -171t172 -64q118 0 190 75.5t81 215.5h184q-6 -196 -132.5 -313t-328.5 -117q-200 0 -313 105t-113 269zM469 983 q0 57 37 94t94 37t94 -37t37 -94t-37 -94t-94 -37t-94 37t-37 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 1308,
    d: "M59 0l508 1413h238l487 -1413h-190l-168 500h-520l-166 -500h-189zM463 643h424l-205 631zM477 1700h164l111 -193h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 1308,
    d: "M59 0l508 1413h238l487 -1413h-190l-168 500h-520l-166 -500h-189zM463 643h424l-205 631zM618 1507l111 193h164l-160 -193h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 1308,
    d: "M59 0l508 1413h238l487 -1413h-190l-168 500h-520l-166 -500h-189zM463 643h424l-205 631zM489 1507l138 193h121l137 -193h-137l-62 113l-61 -113h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 1308,
    d: "M59 0l508 1413h238l487 -1413h-190l-168 500h-520l-166 -500h-189zM463 643h424l-205 631zM469 1536q0 82 26.5 113.5t79.5 31.5q48 0 127 -26q70 -23 91 -23q32 0 32 41h78q0 -82 -26.5 -113.5t-79.5 -31.5q-48 0 -127 26q-70 23 -90 23q-33 0 -33 -41h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 1308,
    d: "M59 0l508 1413h238l487 -1413h-190l-168 500h-520l-166 -500h-189zM449 1604q0 38 28 66t66 28t66 -28t28 -66t-28 -66.5t-66 -28.5t-66 28.5t-28 66.5zM463 643h424l-205 631zM735 1604q0 38 28 66t66 28t66.5 -28t28.5 -66t-28.5 -66.5t-66.5 -28.5t-66 28.5t-28 66.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 1308,
    d: "M59 0l508 1413h238l487 -1413h-190l-168 500h-520l-166 -500h-189zM463 643h424l-205 631zM500 1628q0 71 52 116.5t134 45.5t134 -45.5t52 -116.5t-52 -116.5t-134 -45.5t-134 45.5t-52 116.5zM602 1628q0 -38 23.5 -63t60.5 -25t60.5 25t23.5 63t-23.5 63t-60.5 25 t-60.5 -25t-23.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 1859,
    d: "M-72 0l815 1413h1039v-143h-768l28 -492h678v-143h-669l28 -492h723v-143h-891l-28 500h-482l-282 -500h-191zM481 643h391l-34 629z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 1431,
    d: "M96 700q0 214 82.5 382.5t235.5 264t350 95.5q131 0 236 -36t175 -100.5t111.5 -151t52.5 -191.5l2 -21h-176l-4 21q-32 160 -131.5 250t-269.5 90q-213 0 -340 -166.5t-127 -427.5q0 -264 124 -431t331 -167q170 0 269.5 90t131.5 250l4 20h176l-2 -20 q-10 -97 -50.5 -181t-109.5 -151t-175 -106.5t-238 -41.5l-29 -53q81 -10 123.5 -54t42.5 -116q0 -85 -68.5 -131.5t-183.5 -46.5q-59 0 -102 18v90q43 -22 108 -22q62 0 94.5 24t32.5 66q0 54 -47 77.5t-150 16.5l74 135q-261 32 -407 231t-146 494z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 1202,
    d: "M205 0v1413h919v-143h-743v-492h682v-143h-682v-492h764v-143h-940zM479 1700h164l111 -193h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 1202,
    d: "M205 0v1413h919v-143h-743v-492h682v-143h-682v-492h764v-143h-940zM621 1507l110 193h164l-160 -193h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 1202,
    d: "M205 0v1413h919v-143h-743v-492h682v-143h-682v-492h764v-143h-940zM492 1507l137 193h121l137 -193h-137l-62 113l-61 -113h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 1202,
    d: "M205 0v1413h919v-143h-743v-492h682v-143h-682v-492h764v-143h-940zM451 1604q0 38 28 66t66 28t66 -28t28 -66t-28 -66.5t-66 -28.5t-66 28.5t-28 66.5zM737 1604q0 38 28 66t66 28t66.5 -28t28.5 -66t-28.5 -66.5t-66.5 -28.5t-66 28.5t-28 66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 540,
    d: "M84 1700h164l110 -193h-114zM205 0v1413h176v-1413h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 540,
    d: "M205 0v1413h176v-1413h-176zM225 1507l111 193h164l-160 -193h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 540,
    d: "M96 1507l137 193h121l138 -193h-138l-61 113l-62 -113h-135zM205 0v1413h176v-1413h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 540,
    d: "M55 1604q0 38 28.5 66t66.5 28t66 -28t28 -66t-28 -66.5t-66 -28.5t-66.5 28.5t-28.5 66.5zM205 0v1413h176v-1413h-176zM342 1604q0 38 28 66t66 28t66 -28t28 -66t-28 -66.5t-66 -28.5t-66 28.5t-28 66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 1435,
    d: "M68 625v114h120v674h430q109 0 181 -8q257 -32 408 -204.5t151 -477.5q0 -304 -158.5 -493.5t-411.5 -221.5q-72 -8 -180 -8h-420v625h-120zM365 143h233q110 0 172 11q184 30 289.5 176.5t105.5 392.5q0 232 -101 369.5t-284 167.5q-56 10 -172 10h-243v-531h278v-114 h-278v-482z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 1470,
    d: "M205 0v1413h270l666 -1241q-6 249 -6 535v706h172l4 -1413h-271l-665 1241q6 -249 6 -534v-707h-176zM541 1536q0 82 26.5 113.5t79.5 31.5q48 0 127 -26q70 -23 90 -23q33 0 33 41h78q0 -82 -27 -113.5t-80 -31.5q-48 0 -127 26q-70 23 -90 23q-33 0 -33 -41h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 1509,
    d: "M96 707q0 217 76.5 382t228.5 259t363 94t363 -94t228.5 -259t76.5 -382t-76.5 -381.5t-229 -259.5t-362.5 -95t-362.5 95t-229 259.5t-76.5 381.5zM293 707q0 -277 125 -436.5t346 -159.5t346 159.5t125 436.5q0 278 -124.5 437t-346.5 159t-346.5 -159t-124.5 -437z M555 1700h164l110 -193h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 1509,
    d: "M96 707q0 217 76.5 382t228.5 259t363 94t363 -94t228.5 -259t76.5 -382t-76.5 -381.5t-229 -259.5t-362.5 -95t-362.5 95t-229 259.5t-76.5 381.5zM293 707q0 -277 125 -436.5t346 -159.5t346 159.5t125 436.5q0 278 -124.5 437t-346.5 159t-346.5 -159t-124.5 -437z M696 1507l111 193h164l-160 -193h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 1509,
    d: "M96 707q0 217 76.5 382t228.5 259t363 94t363 -94t228.5 -259t76.5 -382t-76.5 -381.5t-229 -259.5t-362.5 -95t-362.5 95t-229 259.5t-76.5 381.5zM293 707q0 -277 125 -436.5t346 -159.5t346 159.5t125 436.5q0 278 -124.5 437t-346.5 159t-346.5 -159t-124.5 -437z M567 1507l138 193h120l138 -193h-138l-61 113l-62 -113h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 1509,
    d: "M96 707q0 217 76.5 382t228.5 259t363 94t363 -94t228.5 -259t76.5 -382t-76.5 -381.5t-229 -259.5t-362.5 -95t-362.5 95t-229 259.5t-76.5 381.5zM293 707q0 -277 125 -436.5t346 -159.5t346 159.5t125 436.5q0 278 -124.5 437t-346.5 159t-346.5 -159t-124.5 -437z M547 1536q0 82 26.5 113.5t79.5 31.5q48 0 127 -26q70 -23 90 -23q33 0 33 41h78q0 -82 -27 -113.5t-80 -31.5q-47 0 -126 26q-70 23 -91 23q-32 0 -32 -41h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 1509,
    d: "M96 707q0 217 76.5 382t228.5 259t363 94t363 -94t228.5 -259t76.5 -382t-76.5 -381.5t-229 -259.5t-362.5 -95t-362.5 95t-229 259.5t-76.5 381.5zM293 707q0 -277 125 -436.5t346 -159.5t346 159.5t125 436.5q0 278 -124.5 437t-346.5 159t-346.5 -159t-124.5 -437z M526 1604q0 38 28.5 66t66.5 28t66 -28t28 -66t-28 -66.5t-66 -28.5t-66.5 28.5t-28.5 66.5zM813 1604q0 38 28 66t66 28t66 -28t28 -66t-28 -66.5t-66 -28.5t-66 28.5t-28 66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    d: "M227 360l283 283l-283 283l84 84l283 -283l283 283l84 -84l-283 -283l283 -283l-84 -84l-283 283l-283 -283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 1525,
    d: "M88 106l139 140q-123 184 -123 461q0 217 76.5 382t228.5 259t363 94q294 0 471 -180l129 129l84 -84l-137 -138q121 -186 121 -462q0 -217 -76.5 -381.5t-229 -259.5t-362.5 -95q-293 0 -471 181l-129 -129zM301 707q0 -192 59 -328l762 762q-128 162 -350 162 t-346.5 -159t-124.5 -437zM424 274q123 -163 348 -163q221 0 346 159.5t125 436.5q0 191 -59 327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 1396,
    d: "M193 522v891h176v-874q0 -88 4 -125q12 -138 102 -220.5t248 -82.5t248 82.5t102 220.5q4 37 4 125v874h176v-891q0 -86 -4 -127q-8 -91 -43 -166.5t-97.5 -134t-161 -91t-224.5 -32.5t-224.5 32.5t-161 91t-97.5 134t-43 166.5q-4 41 -4 127zM514 1700h164l110 -193 h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 1396,
    d: "M193 522v891h176v-874q0 -88 4 -125q12 -138 102 -220.5t248 -82.5t248 82.5t102 220.5q4 37 4 125v874h176v-891q0 -86 -4 -127q-8 -91 -43 -166.5t-97.5 -134t-161 -91t-224.5 -32.5t-224.5 32.5t-161 91t-97.5 134t-43 166.5q-4 41 -4 127zM655 1507l111 193h164 l-160 -193h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 1396,
    d: "M193 522v891h176v-874q0 -88 4 -125q12 -138 102 -220.5t248 -82.5t248 82.5t102 220.5q4 37 4 125v874h176v-891q0 -86 -4 -127q-8 -91 -43 -166.5t-97.5 -134t-161 -91t-224.5 -32.5t-224.5 32.5t-161 91t-97.5 134t-43 166.5q-4 41 -4 127zM526 1507l138 193h120 l138 -193h-138l-61 113l-61 -113h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 1396,
    d: "M193 522v891h176v-874q0 -88 4 -125q12 -138 102 -220.5t248 -82.5t248 82.5t102 220.5q4 37 4 125v874h176v-891q0 -86 -4 -127q-8 -91 -43 -166.5t-97.5 -134t-161 -91t-224.5 -32.5t-224.5 32.5t-161 91t-97.5 134t-43 166.5q-4 41 -4 127zM485 1604q0 38 28.5 66 t66.5 28t66 -28t28 -66t-28 -66.5t-66 -28.5t-66.5 28.5t-28.5 66.5zM772 1604q0 38 28 66t66 28t66.5 -28t28.5 -66t-28.5 -66.5t-66.5 -28.5t-66 28.5t-28 66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 1189,
    d: "M39 1413h203l393 -686l381 686h198l-499 -856v-557h-176v557zM559 1507l111 193h164l-160 -193h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 1290,
    d: "M205 0v1413h176v-180h272q122 0 185 -8q160 -21 258 -121.5t98 -267.5q0 -168 -98.5 -271.5t-257.5 -124.5q-63 -8 -185 -8h-272v-432h-176zM381 580h272q109 0 158 10q195 45 195 241q0 199 -195 244q-49 10 -158 10h-272v-505z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 1245,
    d: "M152 0v983q0 57 4 131q12 211 142.5 320.5t328.5 109.5q208 0 329 -97.5t121 -260.5q0 -109 -63 -211q-158 -84 -158 -160q0 -53 29 -94t104 -103q93 -75 133.5 -147.5t40.5 -179.5q0 -137 -110.5 -218t-274.5 -81q-100 0 -200 20v142q106 -27 192 -27q98 0 147.5 47.5 t49.5 130.5q0 56 -26.5 104.5t-104.5 116.5q-69 60 -104 99.5t-54 85.5t-19 104q0 148 185 238q37 63 37 131q0 104 -67 162.5t-196 58.5q-120 0 -198 -76t-88 -219q-4 -58 -4 -111v-999h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 1087,
    d: "M74 281q0 187 147.5 279.5t462.5 92.5h70v29q0 90 -4 131q-13 166 -211 166q-216 0 -234 -229h-184q12 172 124 268t294 96q187 0 279 -74t106 -213q6 -64 6 -143v-408q0 -125 20 -276h-176l-18 156l-60 -117q-99 -68 -272 -68q-153 0 -251.5 82t-98.5 228zM266 295 q0 -96 57 -142.5t160 -46.5q125 0 198 80t73 226v110q-233 18 -360.5 -37t-127.5 -190zM317 1413h164l125 -225h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 1087,
    d: "M74 281q0 187 147.5 279.5t462.5 92.5h70v29q0 90 -4 131q-13 166 -211 166q-216 0 -234 -229h-184q12 172 124 268t294 96q187 0 279 -74t106 -213q6 -64 6 -143v-408q0 -125 20 -276h-176l-18 156l-60 -117q-99 -68 -272 -68q-153 0 -251.5 82t-98.5 228zM266 295 q0 -96 57 -142.5t160 -46.5q125 0 198 80t73 226v110q-233 18 -360.5 -37t-127.5 -190zM471 1188l125 225h164l-174 -225h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 1087,
    d: "M74 281q0 187 147.5 279.5t462.5 92.5h70v29q0 90 -4 131q-13 166 -211 166q-216 0 -234 -229h-184q12 172 124 268t294 96q187 0 279 -74t106 -213q6 -64 6 -143v-408q0 -125 20 -276h-176l-18 156l-60 -117q-99 -68 -272 -68q-153 0 -251.5 82t-98.5 228zM266 295 q0 -96 57 -142.5t160 -46.5q125 0 198 80t73 226v110q-233 18 -360.5 -37t-127.5 -190zM344 1188l137 225h121l137 -225h-131l-67 129l-68 -129h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 1087,
    d: "M74 281q0 187 147.5 279.5t462.5 92.5h70v29q0 90 -4 131q-13 166 -211 166q-216 0 -234 -229h-184q12 172 124 268t294 96q187 0 279 -74t106 -213q6 -64 6 -143v-408q0 -125 20 -276h-176l-18 156l-60 -117q-99 -68 -272 -68q-153 0 -251.5 82t-98.5 228zM266 295 q0 -96 57 -142.5t160 -46.5q125 0 198 80t73 226v110q-233 18 -360.5 -37t-127.5 -190zM324 1229q0 82 26.5 113.5t79.5 31.5q48 0 127 -26q70 -23 90 -23q33 0 33 41h78q0 -82 -27 -113.5t-80 -31.5q-48 0 -127 26q-70 23 -90 23q-33 0 -33 -41h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 1087,
    d: "M74 281q0 187 147.5 279.5t462.5 92.5h70v29q0 90 -4 131q-13 166 -211 166q-216 0 -234 -229h-184q12 172 124 268t294 96q187 0 279 -74t106 -213q6 -64 6 -143v-408q0 -125 20 -276h-176l-18 156l-60 -117q-99 -68 -272 -68q-153 0 -251.5 82t-98.5 228zM266 295 q0 -96 57 -142.5t160 -46.5q125 0 198 80t73 226v110q-233 18 -360.5 -37t-127.5 -190zM297 1288q0 38 28 66t66 28t66 -28t28 -66t-28 -66t-66 -28t-66 28t-28 66zM596 1288q0 38 28 66t66 28t66 -28t28 -66t-28 -66t-66 -28t-66 28t-28 66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 1087,
    d: "M74 281q0 187 147.5 279.5t462.5 92.5h70v29q0 90 -4 131q-13 166 -211 166q-216 0 -234 -229h-184q12 172 124 268t294 96q187 0 279 -74t106 -213q6 -64 6 -143v-408q0 -125 20 -276h-176l-18 156l-60 -117q-99 -68 -272 -68q-153 0 -251.5 82t-98.5 228zM266 295 q0 -96 57 -142.5t160 -46.5q125 0 198 80t73 226v110q-233 18 -360.5 -37t-127.5 -190zM354 1329q0 75 52.5 123.5t134.5 48.5t134 -48.5t52 -123.5t-52 -123.5t-134 -48.5t-134.5 48.5t-52.5 123.5zM457 1329q0 -45 23.5 -71.5t60.5 -26.5t60.5 26.5t23.5 71.5t-23.5 71.5 t-60.5 26.5t-60.5 -26.5t-23.5 -71.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 1818,
    d: "M74 281q0 182 153.5 263t477.5 81h69v57q0 297 -235 297q-225 0 -234 -229h-184q4 172 115.5 268t302.5 96q147 0 234 -49t126 -147q129 196 373 196q220 0 342.5 -149t122.5 -392q0 -45 -4 -84h-783q11 -193 95 -288t212 -95q108 0 185.5 64.5t95.5 179.5h184 q-16 -95 -60.5 -169t-109 -119t-141 -68t-162.5 -23q-289 0 -407 236l-56 -111q-145 -125 -348 -125q-155 0 -259.5 82.5t-104.5 227.5zM266 295q0 -96 57 -142.5t160 -46.5q126 0 208.5 88.5t82.5 233.5v61q-96 3 -175.5 1t-141.5 -13.5t-104.5 -33.5t-64.5 -59t-22 -89z M950 625h609q-14 172 -87 263t-204 91q-132 0 -216.5 -91.5t-101.5 -262.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 1083,
    d: "M61 541q0 134 41.5 244t112 181t162 109.5t194.5 38.5q192 0 313 -106t146 -287h-184q-58 258 -279 258q-136 0 -224.5 -108.5t-88.5 -317.5q0 -224 85 -335.5t216 -111.5q108 0 180.5 61t100.5 179h184q-37 -178 -154 -272.5t-291 -102.5l-28 -53q81 -10 123.5 -54 t42.5 -116q0 -85 -68.5 -131.5t-183.5 -46.5q-59 0 -103 18v90q43 -22 109 -22q62 0 94.5 24t32.5 66q0 54 -47 77.5t-150 16.5l74 135q-188 23 -299 165t-111 401z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 1124,
    d: "M61 539q0 260 145.5 417.5t371.5 157.5q219 0 341.5 -148.5t122.5 -392.5q0 -45 -4 -84h-786q11 -202 95.5 -292.5t215.5 -90.5q108 0 185.5 64.5t95.5 179.5h184q-16 -95 -60.5 -169t-109 -119t-141 -68t-162.5 -23q-107 0 -196.5 35.5t-156.5 104.5t-104 178.5 t-37 249.5zM254 625h610q-12 171 -85.5 262.5t-205.5 91.5t-218 -92t-101 -262zM344 1413h164l125 -225h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 1124,
    d: "M61 539q0 260 145.5 417.5t371.5 157.5q219 0 341.5 -148.5t122.5 -392.5q0 -45 -4 -84h-786q11 -202 95.5 -292.5t215.5 -90.5q108 0 185.5 64.5t95.5 179.5h184q-16 -95 -60.5 -169t-109 -119t-141 -68t-162.5 -23q-107 0 -196.5 35.5t-156.5 104.5t-104 178.5 t-37 249.5zM254 625h610q-12 171 -85.5 262.5t-205.5 91.5t-218 -92t-101 -262zM498 1188l125 225h163l-174 -225h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 1124,
    d: "M61 539q0 260 145.5 417.5t371.5 157.5q219 0 341.5 -148.5t122.5 -392.5q0 -45 -4 -84h-786q11 -202 95.5 -292.5t215.5 -90.5q108 0 185.5 64.5t95.5 179.5h184q-16 -95 -60.5 -169t-109 -119t-141 -68t-162.5 -23q-107 0 -196.5 35.5t-156.5 104.5t-104 178.5 t-37 249.5zM254 625h610q-12 171 -85.5 262.5t-205.5 91.5t-218 -92t-101 -262zM371 1188l137 225h121l137 -225h-131l-68 129l-67 -129h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 1124,
    d: "M61 539q0 260 145.5 417.5t371.5 157.5q219 0 341.5 -148.5t122.5 -392.5q0 -45 -4 -84h-786q11 -202 95.5 -292.5t215.5 -90.5q108 0 185.5 64.5t95.5 179.5h184q-16 -95 -60.5 -169t-109 -119t-141 -68t-162.5 -23q-107 0 -196.5 35.5t-156.5 104.5t-104 178.5 t-37 249.5zM254 625h610q-12 171 -85.5 262.5t-205.5 91.5t-218 -92t-101 -262zM324 1288q0 38 28 66t66 28t66 -28t28 -66t-28 -66t-66 -28t-66 28t-28 66zM623 1288q0 38 28 66t66 28t66 -28t28 -66t-28 -66t-66 -28t-66 28t-28 66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 487,
    d: "M16 1413h164l125 -225h-115zM152 0v1085h176v-1085h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 487,
    d: "M152 0v1085h176v-1085h-176zM170 1188l125 225h164l-174 -225h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 487,
    d: "M43 1188l137 225h121l137 -225h-131l-67 129l-68 -129h-129zM152 0v1085h176v-1085h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 487,
    d: "M-4 1288q0 38 28 66t66 28t66 -28t28 -66t-28 -66t-66 -28t-66 28t-28 66zM152 0v1085h176v-1085h-176zM295 1288q0 38 28 66t66 28t66 -28t28 -66t-28 -66t-66 -28t-66 28t-28 66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 1198,
    d: "M61 526q0 134 41 246.5t109.5 186.5t158 114.5t187.5 40.5q76 0 130 -13t110 -46l92 -123q-15 198 -139 325l-283 -116l-41 106l223 92q-74 45 -155 74l110 113q118 -49 207 -119l137 55l41 -106l-86 -35q104 -121 151.5 -290.5t47.5 -401.5q0 -139 -29 -251t-78.5 -187 t-118 -125.5t-145.5 -72.5t-164 -22q-124 0 -221 42t-159 117t-94 175.5t-32 220.5zM254 547q0 -207 83 -324t243 -117q144 0 236.5 108.5t92.5 317.5v60q0 101 -29.5 178.5t-78 121.5t-105.5 65.5t-118 21.5q-143 0 -233.5 -120t-90.5 -312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 1214,
    d: "M152 0v1085h176v-186l67 125q66 52 130.5 71t152.5 19q175 0 275 -85.5t112 -231.5q4 -55 4 -187v-610h-176v598q0 101 -4 156q-8 102 -68 161.5t-180 59.5q-67 0 -121.5 -26.5t-98.5 -82.5t-68.5 -155t-24.5 -234v-477h-176zM408 1229q0 82 26.5 113.5t79.5 31.5 q48 0 127 -26q70 -23 90 -23q33 0 33 41h78q0 -82 -27 -113.5t-80 -31.5q-48 0 -127 26q-70 23 -90 23q-33 0 -33 -41h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 1200,
    d: "M61 543q0 118 33 219.5t97.5 181t169.5 125t239 45.5t239 -45.5t169.5 -125t97.5 -181t33 -219.5q0 -117 -33 -218.5t-97.5 -181.5t-169.5 -126t-239 -46t-239 46t-169.5 126t-97.5 181.5t-33 218.5zM254 543q0 -195 92.5 -316t253.5 -121t253.5 121t92.5 316 q0 196 -92.5 316t-253.5 120t-253.5 -120t-92.5 -316zM377 1413h164l125 -225h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 1200,
    d: "M61 543q0 118 33 219.5t97.5 181t169.5 125t239 45.5t239 -45.5t169.5 -125t97.5 -181t33 -219.5q0 -117 -33 -218.5t-97.5 -181.5t-169.5 -126t-239 -46t-239 46t-169.5 126t-97.5 181.5t-33 218.5zM254 543q0 -195 92.5 -316t253.5 -121t253.5 121t92.5 316 q0 196 -92.5 316t-253.5 120t-253.5 -120t-92.5 -316zM530 1188l125 225h164l-174 -225h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 1200,
    d: "M61 543q0 118 33 219.5t97.5 181t169.5 125t239 45.5t239 -45.5t169.5 -125t97.5 -181t33 -219.5q0 -117 -33 -218.5t-97.5 -181.5t-169.5 -126t-239 -46t-239 46t-169.5 126t-97.5 181.5t-33 218.5zM254 543q0 -195 92.5 -316t253.5 -121t253.5 121t92.5 316 q0 196 -92.5 316t-253.5 120t-253.5 -120t-92.5 -316zM403 1188l138 225h121l137 -225h-131l-68 129l-68 -129h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 1200,
    d: "M61 543q0 118 33 219.5t97.5 181t169.5 125t239 45.5t239 -45.5t169.5 -125t97.5 -181t33 -219.5q0 -117 -33 -218.5t-97.5 -181.5t-169.5 -126t-239 -46t-239 46t-169.5 126t-97.5 181.5t-33 218.5zM254 543q0 -195 92.5 -316t253.5 -121t253.5 121t92.5 316 q0 196 -92.5 316t-253.5 120t-253.5 -120t-92.5 -316zM383 1229q0 82 26.5 113.5t79.5 31.5q48 0 127 -26q70 -23 91 -23q32 0 32 41h78q0 -82 -26.5 -113.5t-79.5 -31.5q-48 0 -127 26q-70 23 -90 23q-33 0 -33 -41h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 1200,
    d: "M61 543q0 118 33 219.5t97.5 181t169.5 125t239 45.5t239 -45.5t169.5 -125t97.5 -181t33 -219.5q0 -117 -33 -218.5t-97.5 -181.5t-169.5 -126t-239 -46t-239 46t-169.5 126t-97.5 181.5t-33 218.5zM254 543q0 -195 92.5 -316t253.5 -121t253.5 121t92.5 316 q0 196 -92.5 316t-253.5 120t-253.5 -120t-92.5 -316zM356 1288q0 38 28.5 66t66.5 28t66 -28t28 -66t-28 -66t-66 -28t-66.5 28t-28.5 66zM655 1288q0 38 28.5 66t66.5 28t66 -28t28 -66t-28 -66t-66 -28t-66.5 28t-28.5 66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    d: "M164 596v115h860v-115h-860zM483 322q0 49 32.5 81.5t82.5 32.5t82.5 -32.5t32.5 -81.5q0 -50 -32.5 -82.5t-82.5 -32.5t-82.5 32.5t-32.5 82.5zM483 977q0 49 32.5 82t82.5 33t82.5 -33t32.5 -82t-32.5 -82t-82.5 -33t-82.5 33t-32.5 82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 1269,
    d: "M53 45l131 131q-104 149 -104 367q0 93 20 177t63 156.5t105.5 125t152 82.5t197.5 30q232 0 371 -133l144 143l84 -84l-152 -151q92 -145 92 -346q0 -117 -33 -218.5t-97.5 -181.5t-169.5 -126t-239 -46q-214 0 -354 117l-127 -127zM272 543q0 -138 45 -234l553 553 q-93 117 -252 117q-161 0 -253.5 -120t-92.5 -316zM383 207q91 -101 235 -101q161 0 254 121.5t93 315.5q0 118 -35 211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 1212,
    d: "M135 434v651h176v-618q0 -77 8 -150q12 -94 78 -150t174 -56q66 0 119.5 26t96.5 82.5t66.5 155t23.5 233.5v477h176v-1085h-176v184l-68 -127q-66 -49 -130.5 -67.5t-152.5 -18.5q-161 0 -261 79t-120 198q-10 69 -10 186zM371 1413h164l124 -225h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 1212,
    d: "M135 434v651h176v-618q0 -77 8 -150q12 -94 78 -150t174 -56q66 0 119.5 26t96.5 82.5t66.5 155t23.5 233.5v477h176v-1085h-176v184l-68 -127q-66 -49 -130.5 -67.5t-152.5 -18.5q-161 0 -261 79t-120 198q-10 69 -10 186zM524 1188l125 225h164l-174 -225h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 1212,
    d: "M135 434v651h176v-618q0 -77 8 -150q12 -94 78 -150t174 -56q66 0 119.5 26t96.5 82.5t66.5 155t23.5 233.5v477h176v-1085h-176v184l-68 -127q-66 -49 -130.5 -67.5t-152.5 -18.5q-161 0 -261 79t-120 198q-10 69 -10 186zM397 1188l138 225h120l138 -225h-131l-68 129 l-68 -129h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 1212,
    d: "M135 434v651h176v-618q0 -77 8 -150q12 -94 78 -150t174 -56q66 0 119.5 26t96.5 82.5t66.5 155t23.5 233.5v477h176v-1085h-176v184l-68 -127q-66 -49 -130.5 -67.5t-152.5 -18.5q-161 0 -261 79t-120 198q-10 69 -10 186zM350 1288q0 38 28 66t66 28t66.5 -28t28.5 -66 t-28.5 -66t-66.5 -28t-66 28t-28 66zM649 1288q0 38 28 66t66 28t66.5 -28t28.5 -66t-28.5 -66t-66.5 -28t-66 28t-28 66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 1050,
    d: "M2 1085h199l323 -954l322 954h192l-446 -1177q-67 -173 -158.5 -255.5t-222.5 -82.5q-63 0 -90 4v143q27 -2 63 -2q84 0 140 43.5t96 147.5l14 39zM457 1188l125 225h163l-174 -225h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 1251,
    d: "M152 -401v1906h176v-594l82 117q46 38 124.5 62t161.5 24q155 0 268 -73t169.5 -197.5t56.5 -284.5q0 -146 -43 -260.5t-117.5 -184.5t-168.5 -106.5t-202 -36.5q-71 0 -145.5 19.5t-114.5 52.5l-71 107v-551h-176zM328 494q0 -101 29.5 -178.5t78 -121.5t105.5 -66 t118 -22q149 0 243.5 113t94.5 320q0 125 -35.5 223t-111 157.5t-180.5 59.5q-70 0 -129.5 -23.5t-108.5 -72t-76.5 -133t-27.5 -197.5v-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 1050,
    d: "M2 1085h199l323 -954l322 954h192l-446 -1177q-67 -173 -158.5 -255.5t-222.5 -82.5q-63 0 -90 4v143q27 -2 63 -2q84 0 140 43.5t96 147.5l14 39zM283 1288q0 38 28 66t66 28t66 -28t28 -66t-28 -66t-66 -28t-66 28t-28 66zM582 1288q0 38 28 66t66 28t66 -28t28 -66 t-28 -66t-66 -28t-66 28t-28 66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0152",
    horizAdvX: 2232,
    d: "M96 707q0 155 44 289t125 233t204.5 156t273.5 57q156 0 255.5 -40t181.5 -136l55 -146v293h919v-143h-743v-492h682v-143h-682v-492h764v-143h-940v289l-55 -150q-147 -168 -437 -168q-150 0 -273.5 57.5t-204.5 157t-125 233.5t-44 288zM293 707q0 -268 126 -432 t345 -164t345 164t126 432q0 269 -125.5 432.5t-345.5 163.5t-345.5 -163.5t-125.5 -432.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0153",
    horizAdvX: 2009,
    d: "M61 543q0 118 33 219.5t97.5 181t169.5 125t239 45.5q316 0 444 -264q128 264 418 264q220 0 342.5 -149t122.5 -392q0 -45 -4 -84h-782q11 -193 95 -288t212 -95q108 0 185.5 64.5t95.5 179.5h184q-16 -95 -60.5 -169t-109 -119t-141 -68t-162.5 -23q-283 0 -404 258 q-128 -258 -436 -258q-134 0 -239 46t-169.5 126t-97.5 181.5t-33 218.5zM254 543q0 -195 92.5 -316t253.5 -121t253.5 121t92.5 316q0 196 -92.5 316t-253.5 120t-253.5 -120t-92.5 -316zM1141 625h608q-14 172 -87 263t-204 91q-132 0 -216 -91.5t-101 -262.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0178",
    horizAdvX: 1189,
    d: "M39 1413h203l393 -686l381 686h198l-499 -856v-557h-176v557zM389 1604q0 38 28 66t66 28t66.5 -28t28.5 -66t-28.5 -66.5t-66.5 -28.5t-66 28.5t-28 66.5zM676 1604q0 38 28 66t66 28t66 -28t28 -66t-28 -66.5t-66 -28.5t-66 28.5t-28 66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C6",
    horizAdvX: 614,
    d: "M111 1188l137 225h121l137 -225h-131l-68 129l-67 -129h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DC",
    horizAdvX: 614,
    d: "M90 1229q0 82 27 113.5t80 31.5q48 0 127 -26q70 -23 90 -23q32 0 32 41h78q0 -82 -26.5 -113.5t-79.5 -31.5q-48 0 -127 26q-70 23 -90 23q-33 0 -33 -41h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2000",
    horizAdvX: 895
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2001",
    horizAdvX: 1790
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2002",
    horizAdvX: 895
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2003",
    horizAdvX: 1790
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2004",
    horizAdvX: 596
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2005",
    horizAdvX: 447
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2006",
    horizAdvX: 298
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2007",
    horizAdvX: 298
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2008",
    horizAdvX: 223
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2009",
    horizAdvX: 358
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u200A",
    horizAdvX: 99
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2010",
    horizAdvX: 561,
    d: "M66 522v115h430v-115h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2011",
    horizAdvX: 561,
    d: "M66 522v115h430v-115h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2012",
    horizAdvX: 561,
    d: "M66 522v115h430v-115h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 1024,
    d: "M143 541v114h738v-114h-738z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 2048,
    d: "M143 541v114h1762v-114h-1762z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 505,
    d: "M111 993v21l192 491h158l-160 -512h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 505,
    d: "M45 993l160 512h190v-20l-192 -492h-158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 450,
    d: "M-63 -246l159 451h191v-21l-185 -430h-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 854,
    d: "M111 993v21l192 491h158l-160 -512h-190zM459 993v21l192 491h158l-160 -512h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 854,
    d: "M45 993l160 512h190v-20l-192 -492h-158zM393 993l160 512h190v-20l-192 -492h-158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 798,
    d: "M-63 -246l159 451h191v-21l-185 -430h-165zM285 -246l159 451h191v-21l-184 -430h-166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 745,
    d: "M160 625q0 91 61 152t152 61t152 -61t61 -152t-61 -152t-152 -61t-152 61t-61 152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2026",
    horizAdvX: 1269,
    d: "M76 102q0 57 37 94t94 37t94 -37t37 -94t-37 -94t-94 -37t-94 37t-37 94zM485 102q0 57 37 94t94 37t94.5 -37t37.5 -94t-37.5 -94t-94.5 -37t-94 37t-37 94zM895 102q0 57 37 94t94 37t94 -37t37 -94t-37 -94t-94 -37t-94 37t-37 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u202F",
    horizAdvX: 358
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 792,
    d: "M246 508l280 340h150l-281 -340l281 -340h-150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 792,
    d: "M117 168l280 340l-280 340h149l281 -340l-281 -340h-149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u205F",
    horizAdvX: 447
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u20AC",
    d: "M61 532l21 115h115v53q0 40 2 58h-101l21 114h88q39 285 198.5 427.5t409.5 142.5q225 0 334 -127l-86 -117q-45 51 -111 78t-141 27q-165 0 -272.5 -102.5t-135.5 -328.5h607l-23 -114h-594v-49q0 -42 2 -62h576l-19 -115h-549q27 -219 128 -320t274 -101q172 0 301 82 v-146q-133 -76 -311 -76q-130 0 -228 29t-175.5 93t-124 173.5t-62.5 265.5h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2122",
    horizAdvX: 1103,
    d: "M41 1268v84h405v-84h-151v-334h-102v334h-152zM496 934v416h153l88 -318l88 318h150v-416h-103l5 291l-89 -283h-106l-86 281l2 -289h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u25FC",
    horizAdvX: 1085,
    d: "M0 0v1085h1085v-1085h-1085z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "U",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "U",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "U",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "U",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "U",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "U",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "U",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "z",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "period,ellipsis",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "T",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,uniFB02",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,uniFB02",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "T",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Y,Yacute,Ydieresis",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,oe",
    g2: "x",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,oe",
    g2: "y,yacute,ydieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "T",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Y,Yacute,Ydieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "period,ellipsis",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 274
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y,Yacute,Ydieresis",
    k: 342
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 229
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 168
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "T",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "Y,Yacute,Ydieresis",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "y,yacute,ydieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "V",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "W",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "quoteright,quotedblright",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "S",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "w",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "m,n,p,r,ntilde",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "b,h,k,thorn",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 49
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAileronRegularWebfont);
export default __webpack_public_path__ + "static/media/aileron-regular-webfont.a8f19ae2efa5eaff5c053f2bf7104acf.svg";
export { ForwardRef as ReactComponent };